import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "pattern", "value", "maxlength", "disabled", "readonly", "placeholder", "data-1p-ignore"]

import { getMask } from '@/plugins'
import { ref, useTemplateRef, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FormInput',
  props: /*@__PURE__*/_mergeModels({
    type: { default: "text" },
    pattern: {},
    maxLength: {},
    placeholder: {},
    isReadonly: { type: Boolean, default: false },
    isDisabled: { type: Boolean },
    allowOnePass: { type: Boolean, default: false }
  }, {
    "modelValue": {
  default: null
},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const localValue = ref<string|null>(null);
const inputRef = useTemplateRef<HTMLInputElement>("input");
const modelValue = _useModel<object|string|number|null>(__props, "modelValue");



function handleInput(event: Event) {
  const value = (event.target as HTMLInputElement).value;

  if (value.length === 0) {
    modelValue.value = null;
    return;
  }

  switch (__props.type) {
    case "number":
      modelValue.value = Number(value);
    break;

    default:
      modelValue.value = value;
    break;
  }
}

watch(modelValue, modelValue => {
  if (!modelValue && modelValue !== 0) {
    localValue.value = null;
    return;
  }

  localValue.value = modelValue.toString();
}, { immediate: true });

watch([inputRef, () => __props.pattern, localValue], ([input, pattern, value], __, onCleanup) => {
  if (!input || !pattern) {
    return;
  }

  const mask = getMask(pattern, input);

  if (value) {
    mask.value = value;
    modelValue.value = mask.value;
  }

  onCleanup(() => mask.destroy());
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    ref: "input",
    type: _ctx.type,
    pattern: _ctx.pattern,
    value: localValue.value,
    onInput: handleInput,
    maxlength: _ctx.maxLength,
    disabled: _ctx.isDisabled,
    readonly: _ctx.isReadonly,
    placeholder: _ctx.placeholder,
    "data-1p-ignore": !_ctx.allowOnePass,
    class: "block text-left w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 sm:text-sm/6 disabled:bg-gray-200 disabled:hover:cursor-not-allowed"
  }, null, 40, _hoisted_1))
}
}

})